import { randomBytes } from "./crypto";
import { toB64, fromB64 } from "./encoding";
import { deriveKeyFromPassword } from "./argon2";
import { generateDEK, wrapDEK, unwrapDEK } from "./dek";
import { clearKeyFromDB, saveKeyToDB } from "./storage";

export interface WrappedKeyState {
  salt: string;
  wrapped: string;
  iv: string;
}

export async function createVault(masterPassword: string): Promise<{
  dek: CryptoKey;
  wrappedState: WrappedKeyState;
}> {
  const salt = randomBytes(16);
  const kek = await deriveKeyFromPassword(masterPassword, salt);
  const dek = await generateDEK();
  const { wrapped, iv } = await wrapDEK(dek, kek);

  const wrappedState: WrappedKeyState = {
    salt: toB64(salt),
    wrapped: toB64(wrapped),
    iv: toB64(iv),
  };

  await saveKeyToDB(dek);

  return { dek, wrappedState };
}

export async function unlockVault(masterPassword: string, stored: WrappedKeyState): Promise<CryptoKey> {
  const kek = await deriveKeyFromPassword(masterPassword, fromB64(stored.salt));
  const dek = await unwrapDEK(fromB64(stored.wrapped), fromB64(stored.iv), kek);
  await saveKeyToDB(dek);

  return dek;
}

export async function deleteVault(): Promise<void> {
  await clearKeyFromDB();
}
